/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Shrink",
  size: 20
}

const SvgShrink = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M11 4h1v4h4v1h-5zM4 11h5v5H8v-4H4z" />
    <path fill="none" strokeWidth={1.1} d="M12 8l6-6M2 18l6-6" />
  </Svg>
)

SvgShrink.defaultProps = defaultProps
export default SvgShrink
